import { Box, Button, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { ReactComponent as LinkExpiredIcon } from '../../assets/images/link-expired.svg';
import { LOGIN_CONTENT_MAX_WIDTH } from '../../constants/auth';
import { routes } from '../../constants/routing';
import LoginPageLayout from './LoginPageLayout';

const LinkExpiredContainer = () => {
  const history = useHistory();

  const handleSendNewLink = useCallback(() => {
    history.push(routes.login);
  }, [history]);

  return (
    <LoginPageLayout>
      <Box sx={{ width: '100%', maxWidth: LOGIN_CONTENT_MAX_WIDTH }}>
        <Box
          sx={{
            mt: 8,
            mb: 4,
            display: 'flex',
            justifyContent: 'center',
            '& svg': { width: 100, height: 'auto' },
          }}
        >
          <LinkExpiredIcon />
        </Box>

        <Typography component="h1" variant="h4" align="center" sx={{ mb: 2 }}>
          Link no longer works
        </Typography>

        <Typography variant="body2" color="text.secondary" fontWeight="medium" sx={{ mb: 3 }}>
          This sign-in link has expired or already been used. Links are valid for 6 hours and can only be used once.
        </Typography>

        <Button
          type="button"
          variant="contained"
          size="large"
          fullWidth
          onClick={handleSendNewLink}
          sx={{
            minHeight: 48,
            py: 1.5,
            px: 2.75,
          }}
        >
          Send a new link
        </Button>
      </Box>
    </LoginPageLayout>
  );
};

export default LinkExpiredContainer;
